import { TTimeSlot, TEditAppealTimeSlot } from '../../type'

//  приведение данных о таймслоте к нужному типу

export const initSelectedTimeSlots = (
  appealTimeSlotValue: TTimeSlot[],
): TEditAppealTimeSlot[] => {
  const timeSlotsListValue = appealTimeSlotValue.map(slot => {
    return {
      date: slot.dateFrom,
      id: slot.id,
      key: slot.key,
    }
  })

  return timeSlotsListValue
}
